<template>
  <div class="c-toolbar c-toolbar--warning hide-for-print">
    <transition name="fade">
      <div class="inner" v-if="$store.state.covid19.filter_available">
        <div class="inner-wrapper">
          <div class="c-toolbar__content">
            Global Monitor of COVID-19´s impact on Democracy and Human Rights <a class="pl-10" :href="aboutUrl">read more</a>
          </div>
          <transition name="fade">
            <div class="c-toolbar__explainer" v-if="$store.state.covid19.is_enabled">
              <div class="c-toolbar__explainer__item">
                <ConcerningDevelopments style="margin-bottom: -4px" :size="35"></ConcerningDevelopments>
                <div>
                  Concerning developments
                </div>
              </div>

              <div class="c-toolbar__explainer__item">
                <DevelopmentsToWatch style="margin-bottom: -4px" :size="35"></DevelopmentsToWatch>
                <div>
                  Developments to watch
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="alert-application" style="background-color: #10637e;color: white;padding: 15px 20px;">
          <p style="margin: 0;line-height: 1.5;">
            Thank you for visiting International IDEA’s Global Monitor of Covid-19’s Impact on Democracy and Human Rights. We are currently developing a new Global Monitor space, and the February 2022 updates mark the end of the current tool. Please watch this space for a new and improved resource in the near future!
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import _ from 'lodash'
// import {EventBus} from '@/event-bus.js'
import DevelopmentsToWatch from './../icons/DevelopmentsToWatch.vue'
import ConcerningDevelopments from './../icons/ConcerningDevelopments.vue'

export default {
  name: 'covidtoolbar',
  components: {
    ConcerningDevelopments,
    DevelopmentsToWatch
  },
  computed: {
    aboutUrl () {
      return process.env.APP_URL + 'about-covid19'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .c-toolbar {
    line-height: 1;
    position: relative;
    z-index: 200;

    & .inner-wrapper {
      display: flex; -js-display: flex;
      flex-wrap: nowrap;
      width: 100%;
    }

    &__cta {
      align-items: center;
      background: $covid19;
      color: $white;
      cursor: pointer;
      display: flex; -js-display: flex;
      flex: none;
      flex-wrap: nowrap;
      justify-content: space-between;
      padding: 15px 20px;

      .icon { flex: none; }
      .checkbox { flex: none; }
      .content {
        flex: 1 1 auto;
        padding: 0 1em;
        text-transform: uppercase;
      }
    }

    &__content {
      flex: 1 1 auto;
      padding: 15px 20px;
      line-height: 25px;
    }

    &__explainer {
      align-items: center;
      flex: none;
      margin-top: 10px;

      &__item {
        display: flex; -js-display: flex;
        margin-right: 20px;
        align-items: center;

        & > * { flex: 1 1 auto; }
      }

      @media (min-width: 1200px) {
        display: flex; -js-display: flex;
        flex-wrap: nowrap;
        justify-content: flex-end;
        margin-top: 0;

        &__item {
          flex: 1 1 auto;
        }
      }
    }

    a {
      color: $gray-darkest;
      font-weight: bold;

      &:hover {
        color: $blue;
      }
    }
  }

  .c-toolbar--warning{
    background: $covid19-light;
  }


</style>



// WEBPACK FOOTER //
// src/components/shared/misc/CovidToolbar.vue